module.exports = __webpack_public_path__ + "img/comment_4.53ade7dc.png";